module.exports = __webpack_public_path__ + "static/media/toggle-up.5d04052a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/toggle-up.svg
// module id = 818
// module chunks = 0